import React, {useState} from 'react';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import {AppDrawerItem} from './AppDrawerItem';
import classNames from './AppDrawer.module.css';
import {useUser} from "./ProtectedRoute";

export const AppDrawer = () => {
    const {user} = useUser()

    const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    return (
        <>
            <IconButton
                className={classNames.button}
                color="inherit"
                edge="start"
                onClick={() => setIsDrawerOpen(true)}
                size="large"
            >
                <MenuIcon />
            </IconButton>

            <Drawer
                anchor="left"
                onClose={() => setIsDrawerOpen(false)}
                open={isDrawerOpen}
            >
                <div className={classNames.content}>
                    <div className={classNames.header}>
                        <IconButton
                            className={classNames.button}
                            onClick={() => setIsDrawerOpen(false)}
                        >
                            {<ChevronLeftIcon />}
                        </IconButton>

                        <Typography
                            variant="h6"
                            component="div"
                        >
                            Marahel
                        </Typography>
                    </div>

                    <Divider />

                    <List>
                        <AppDrawerItem icon={<AssignmentLateIcon />} label="Leads" route="/leads"/>
                        <AppDrawerItem icon={<AssignmentTurnedInIcon />} label="Applications" route="/applications"/>
                    </List>

                    <Divider />

                    <List>
                        <AppDrawerItem icon={<AssignmentReturnedIcon />} label="Stages" route="/stages"/>
                        <AppDrawerItem icon={<AssignmentIcon />} label="Packages" route="/packages"/>

                        {user.role === 'ADMIN' && (
                            <AppDrawerItem icon={<AssignmentIndIcon />} label="Users" route="/users"/>
                        )}
                    </List>
                </div>
            </Drawer>
        </>
    )
}
